import { styled } from 'styled-components';
import { heading2, textExtraTinyNormal } from '../DesignSystem/Typography';

export const Container = styled.div`

  .label {
    display: flex;
    gap: var(--space-50);
    align-items: center;
    justify-content: center;
    cursor: pointer;
    ${heading2};
    color: var(--text-primary);

    .serviceCounter {
      position: relative;
      top: -1px;
      width: 20px;
      height: 20px;
      ${textExtraTinyNormal};
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-left: var(--space-100);

      background: var(--text-primary);
      color: var(--text-primary-dark);
      border-radius: 50%;
    }

    button {
      position: relative;
      top: 1px;
    }
  }
`
